import { render } from "./MyTeamPage.vue?vue&type=template&id=bd5218f8&scoped=true"
import script from "./MyTeamPage.vue?vue&type=script&lang=js"
export * from "./MyTeamPage.vue?vue&type=script&lang=js"

import "./MyTeamPage.vue?vue&type=style&index=0&id=bd5218f8&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5218f8"]])

export default __exports__